// ==== Custom functions for Historical =======================================================
import { select, event, timeFormat } from "d3";
import { historicalTooltip } from "@/_core/charts/D3ChartAnalyticsChartHelpers";
import {
  CPOColombiaFwdTooltip,
  CPOColombiaFwdTooltipCurrency,
  CPOColombiaFwdTooltipCommodity,
  CPOColombiaFwdTooltipCommodity2,
  CPOColombiaFwdTooltipCommodity3,
  CPOColombiaComparisonHistTooltip,
  populateTableFEP,
  populateTableFEPComp
} from "@/_core/data/Markets";
import {
  bandsCreate,
  dotCreate,
  hLineCreate
} from "@/_core/charts/D3ChartHoverHelpers";
import { grayLightBackground } from "@/_core/_helpers/_parametric_tools";

export const D3HoverMktHist = function() {};

D3HoverMktHist.prototype.hoverFct = function(
  svg,
  data,
  customName,
  formatNumber,
  dateFormat,
  title,
  axisFormatNumber = null,
  svg1,
  svg2,
  chartNum,
  isCandles = true,
  allData,
  isFEP,
  colorTheme
) {
  let auxCustomName;
  if (chartNum === 1) {
    auxCustomName = customName;
  } else {
    auxCustomName = customName.substring(0, customName.length - 1);
  }
  let sharp = "#";
  select(`${sharp}${svg.parentElement}`)
    .selectAll(".tooltip")
    .remove();
  let divW = Math.min(1.75 * svg.width, 450);
  let Tooltip = select(`${sharp}${svg.parentElement}`)
    .append("div")
    .style("opacity", 0)
    .style("margin", "0 auto")
    .style("text-align", "center")
    .style("padding", "0")
    .attr("class", "tooltip tooltip-transparent")
    .style("font-size", "0.5rem")
    .style("width", divW + "px")
    .style("line-height", "1")
    .html("");
  let Tooltip2 = select(`${sharp}${svg.parentElement}`)
    .append("div")
    .style("opacity", 0)
    .style("margin", "0 auto")
    .style("text-align", "center")
    .style("padding", "2px")
    .attr("class", "tooltip")
    .style("font-size", "0.8rem")
    .style("width", "70px")
    .html("");

  let tooltipWidth2 = 80;
  let Tooltip3 = select(`${sharp}${svg.parentElement}`)
    .append("div")
    .style("opacity", 0)
    .style("margin", 0)
    .style("text-align", "center")
    .style("padding", "2px")
    .attr("class", "tooltip")
    .style("font-size", "0.8rem")
    .style("width", tooltipWidth2 + "px")
    .html("");

  var mouseOver = function(d, i) {
    event.preventDefault();
    const yPixels = Math.max(
      Math.min(event.layerY - svg.margin.top, svg.height),
      0
    );

    select(".hHoverLine" + auxCustomName)
      .style("opacity", 1)
      .attr("y1", yPixels)
      .attr("y2", yPixels);
    select(".hHoverLine" + auxCustomName + "b")
      .style("opacity", 1)
      .attr("y1", yPixels)
      .attr("y2", yPixels);

    let txt;
    if (chartNum === 1) {
      select(".bandsMAL" + d.id).classed("hoved", true);
      select(".stickMAL" + d.id).classed("hoved", true);
      select(".stick2MAL" + d.id).classed("hoved", true);
      select(".candleMAL" + d.id).classed("hoved", true);
      select(".bandsRATE" + d.id).classed("hoved", true);
      select(".stickRATE" + d.id).classed("hoved", true);
      select(".stick2RATE" + d.id).classed("hoved", true);
      select(".candleRATE" + d.id).classed("hoved", true);
      select(".bandsROTT" + d.id).classed("hoved", true);
      select(".stickROTT" + d.id).classed("hoved", true);
      select(".stick2ROTT" + d.id).classed("hoved", true);
      select(".candleROTT" + d.id).classed("hoved", true);
      select(".barROTT" + d.id).classed("hoved", true);

      select(".dot" + customName)
        .style("opacity", 1)
        .attr(
          "transform",
          `translate(${svg.x(d.date) + svg.x.bandwidth() / 2},${svg.y(
            d.close
          )})`
        );

      let divWAux = 0.5 * divW;
      if (isCandles === true) {
        divWAux = Math.min(700, divW);
        txt = historicalTooltip(d, title, dateFormat, formatNumber);
      } else {
        txt = CPOColombiaFwdTooltip(
          d,
          title,
          dateFormat,
          formatNumber,
          "SETTLE"
        );
      }
      Tooltip.style("opacity", 1)
        .style("left", svg.margin.left + 1 + "px")
        .style("right", null)
        .style("top", svg.margin.top + 1 + "px")
        .style("width", divWAux + "px")
        .html(txt);
    } else {
      select(".bandsMALb" + d.id).classed("hoved", true);
      select(".bandsRATEb" + d.id).classed("hoved", true);
      select(".bandsROTTb" + d.id).classed("hoved", true);
      select(".barMALb" + d.id).classed("hoved", true);
      select(".barRATEb" + d.id).classed("hoved", true);
      select(".barROTTb" + d.id).classed("hoved", true);

      let keys = Object.keys(d);
      let divWAux = 0.5 * divW;
      if (keys.indexOf("ave1") > -1) {
        if (isCandles === false) {
          if (d.close != null) {
            txt = CPOColombiaFwdTooltip(d, title, "%b %y", formatNumber);
          } else {
            txt = CPOColombiaFwdTooltipCommodity3(
              d,
              title,
              "%b %y",
              formatNumber
            );
          }
        } else if (d.n2 > 0) {
          txt = CPOColombiaFwdTooltipCommodity(d, title, "%b %y", formatNumber);
          divWAux = Math.min(480, 1.9 * (svg.width + svg.margin.left));
        } else {
          if (d.close != null) {
            txt = CPOColombiaFwdTooltipCommodity2(
              d,
              title,
              "%b %y",
              formatNumber
            );
            divWAux = Math.min(480, 0.9 * divW);
          } else {
            txt = CPOColombiaFwdTooltipCommodity3(
              d,
              title,
              "%b %y",
              formatNumber
            );
          }
        }
      } else if (keys.indexOf("curr_fwd") > -1) {
        if (isFinite(d.curr_ave) && d.curr_ave != null) {
          txt = CPOColombiaFwdTooltipCurrency(d, title, "%b %y", formatNumber);
          divWAux = Math.min(480, 0.9 * divW);
        } else {
          txt = CPOColombiaFwdTooltip(d, title, "%b %y", formatNumber);
        }
      } else {
        txt = CPOColombiaFwdTooltip(d, title, "%b %y", formatNumber);
      }

      Tooltip.style("opacity", 1)
        .style("right", svg.margin.right - 1 + "px")
        .style("left", null)
        .style("top", svg.margin.top + 1 + "px")
        .style("width", divWAux + "px")
        .html(txt);
    }

    if (chartNum === 1) {
      Tooltip2.style("opacity", 1)
        .style(
          "left",
          svg1.width +
            svg1.margin.left +
            svg1.margin.right +
            svg2.width +
            svg2.margin.left +
            1 +
            "px"
        )
        .style("top", yPixels + svg1.margin.top - 11 + "px")
        .html(axisFormatNumber(svg1.y.invert(yPixels)));
    } else {
      populateTableFEP(allData[i], formatNumber, timeFormat("%b %y"));

      Tooltip2.style("opacity", 1)
        .style("left", svg2.width + 1 + "px")
        .style("top", yPixels + svg2.margin.top - 11 + "px")
        .html(axisFormatNumber(svg2.y.invert(yPixels)));
    }

    Tooltip3.style("opacity", 1)
      .style(
        "left",
        svg.x(d.date) +
          svg.x.bandwidth() / 2 +
          svg.margin.left -
          tooltipWidth2 / 2 +
          "px"
      )
      .style("top", svg.height + svg.margin.top + 1 + "px")
      .html(timeFormat(dateFormat)(d.date));
  };

  var mouseLeave = function(d) {
    select(".hHoverLine" + auxCustomName)
      .style("opacity", 0)
      .attr("display", null);
    select(".hHoverLine" + auxCustomName + "b")
      .style("opacity", 0)
      .attr("display", null);
    // === rates chart
    select(".hHoverLineRATES")
      .style("opacity", 0)
      .attr("display", null);

    Tooltip.style("left", "-1000000px")
      .style("top", "0px")
      .style("opacity", 0)
      .style("width", divW + "px")
      .html("");

    Tooltip2.style("right", 0)
      .style("top", "0px")
      .style("opacity", 0)
      .html("");

    Tooltip3.style("left", "-1000000px")
      .style("top", "0px")
      .style("opacity", 0)
      .html("");

    if (chartNum === 1) {
      select(".bandsMAL" + d.id).classed("hoved", false);
      select(".stickMAL" + d.id).classed("hoved", false);
      select(".stick2MAL" + d.id).classed("hoved", false);
      select(".candleMAL" + d.id).classed("hoved", false);
      select(".bandsRATE" + d.id).classed("hoved", false);
      select(".stickRATE" + d.id).classed("hoved", false);
      select(".stick2RATE" + d.id).classed("hoved", false);
      select(".candleRATE" + d.id).classed("hoved", false);
      select(".bandsROTT" + d.id).classed("hoved", false);
      select(".stickROTT" + d.id).classed("hoved", false);
      select(".stick2ROTT" + d.id).classed("hoved", false);
      select(".candleROTT" + d.id).classed("hoved", false);
      select(".barROTT" + d.id).classed("hoved", false);

      select(".dot" + customName)
        .style("opacity", 0)
        .attr("display", null);
    } else {
      select(".bandsMALb" + d.id).classed("hoved", false);
      select(".bandsRATEb" + d.id).classed("hoved", false);
      select(".bandsROTTb" + d.id).classed("hoved", false);
      select(".barMALb" + d.id).classed("hoved", false);
      select(".barRATEb" + d.id).classed("hoved", false);
      select(".barROTTb" + d.id).classed("hoved", false);
    }
    populateTableFEP(
      isFEP ? allData[0] : allData[1],
      formatNumber,
      timeFormat("%b %y")
    );
  };
  if (isCandles === false && isFEP === false) {
    dotCreate(svg, customName, 3, "white", "gray");
  }
  hLineCreate(svg, customName, grayLightBackground(colorTheme), 1);
  bandsCreate(
    data,
    svg,
    customName,
    mouseOver,
    mouseLeave,
    mouseOver,
    true,
    "id"
  );
  populateTableFEP(
    isFEP ? allData[0] : allData[1],
    formatNumber,
    timeFormat("%b %y")
  );
};

D3HoverMktHist.prototype.hoverFctComp = function(
  svg,
  data1,
  data2,
  customName,
  formatNumber,
  dateFormat,
  title,
  axisFormatNumber = null,
  svg1,
  svg2,
  chartNum,
  allData,
  allData2,
  comp,
  compRott,
  colorTheme
) {
  let auxCustomName;
  if (chartNum === 1) {
    auxCustomName = customName;
  } else {
    auxCustomName = customName.substring(0, customName.length - 1);
  }
  let sharp = "#";
  select(`${sharp}${svg.parentElement}`)
    .selectAll(".tooltip")
    .remove();
  let divW = Math.min(1.75 * svg.width, 450);
  let Tooltip = select(`${sharp}${svg.parentElement}`)
    .append("div")
    .style("opacity", 0)
    .style("margin", "0 auto")
    .style("text-align", "center")
    .style("padding", "0")
    .attr("class", "tooltip tooltip-transparent")
    .style("font-size", "0.5rem")
    .style("width", divW + "px")
    .style("line-height", "1")
    .html("");
  let Tooltip2 = select(`${sharp}${svg.parentElement}`)
    .append("div")
    .style("opacity", 0)
    .style("margin", "0 auto")
    .style("text-align", "center")
    .style("padding", "2px")
    .attr("class", "tooltip")
    .style("font-size", "0.8rem")
    .style("width", "70px")
    .html("");

  let tooltipWidth2 = 80;
  let Tooltip3 = select(`${sharp}${svg.parentElement}`)
    .append("div")
    .style("opacity", 0)
    .style("margin", 0)
    .style("text-align", "center")
    .style("padding", "2px")
    .attr("class", "tooltip")
    .style("font-size", "0.8rem")
    .style("width", tooltipWidth2 + "px")
    .html("");

  var mouseOver = function(d, i) {
    event.preventDefault();
    const yPixels = Math.max(
      Math.min(event.layerY - svg.margin.top, svg.height),
      0
    );

    select(".hHoverLine" + auxCustomName)
      .style("opacity", 1)
      .attr("y1", yPixels)
      .attr("y2", yPixels);
    select(".hHoverLine" + auxCustomName + "b")
      .style("opacity", 1)
      .attr("y1", yPixels)
      .attr("y2", yPixels);

    let txt;
    if (chartNum === 1) {
      select(".bandsRATE" + d.id).classed("hoved", true);
      select(".barROTT" + d.id).classed("hoved", true);
      select(".barMAL" + d.id).classed("hoved", true);

      let divWAux = 0.75 * divW;

      txt = CPOColombiaComparisonHistTooltip(
        data1[i],
        data2[i],
        title,
        dateFormat,
        formatNumber
      );

      Tooltip.style("opacity", 1)
        .style("left", svg.margin.left + 1 + "px")
        .style("right", null)
        .style("top", svg.margin.top + 1 + "px")
        .style("width", divWAux + "px")
        .html(txt);
    } else {
      select(".bandsRATEb" + i).classed("hoved", true);
      select(".barMALb" + i).classed("hoved", true);
      select(".barRATEb" + i).classed("hoved", true);

      let divWAux = 1.5 * divW;
      txt = CPOColombiaComparisonHistTooltip(
        data1[i],
        data2[i],
        title,
        dateFormat,
        formatNumber,
        2,
        comp,
        compRott
      );

      Tooltip.style("opacity", 1)
        .style("right", svg.margin.right - 1 + "px")
        .style("left", null)
        .style("top", svg.margin.top + 1 + "px")
        .style("width", divWAux + "px")
        .html(txt);
    }

    if (chartNum === 1) {
      Tooltip2.style("opacity", 1)
        .style(
          "left",
          svg1.width +
            svg1.margin.left +
            svg1.margin.right +
            svg2.width +
            svg2.margin.left +
            1 +
            "px"
        )
        .style("top", yPixels + svg1.margin.top - 11 + "px")
        .html(axisFormatNumber(svg1.y.invert(yPixels)));
    } else {
      populateTableFEPComp(
        allData[i],
        allData2[i],
        formatNumber,
        timeFormat("%b %y"),
        comp,
        compRott
      );

      Tooltip2.style("opacity", 1)
        .style("left", svg2.width + 1 + "px")
        .style("top", yPixels + svg2.margin.top - 11 + "px")
        .html(axisFormatNumber(svg2.y.invert(yPixels)));
    }

    Tooltip3.style("opacity", 1)
      .style(
        "left",
        svg.x(d.date) +
          svg.x.bandwidth() / 2 +
          svg.margin.left -
          tooltipWidth2 / 2 +
          "px"
      )
      .style("top", svg.height + svg.margin.top + 1 + "px")
      .html(timeFormat(dateFormat)(d.date));
  };

  var mouseLeave = function(d, i) {
    select(".hHoverLine" + auxCustomName)
      .style("opacity", 0)
      .attr("display", null);
    select(".hHoverLine" + auxCustomName + "b")
      .style("opacity", 0)
      .attr("display", null);
    // === rates chart
    select(".hHoverLineRATES")
      .style("opacity", 0)
      .attr("display", null);

    Tooltip.style("left", "-1000000px")
      .style("top", "0px")
      .style("opacity", 0)
      .style("width", divW + "px")
      .html("");

    Tooltip2.style("right", 0)
      .style("top", "0px")
      .style("opacity", 0)
      .html("");

    Tooltip3.style("left", "-1000000px")
      .style("top", "0px")
      .style("opacity", 0)
      .html("");

    if (chartNum === 1) {
      select(".bandsRATE" + d.id).classed("hoved", false);
      select(".barROTT" + d.id).classed("hoved", false);
      select(".barMAL" + d.id).classed("hoved", false);

      select(".dot" + customName)
        .style("opacity", 0)
        .attr("display", null);
    } else {
      select(".bandsRATEb" + i).classed("hoved", false);
      select(".barMALb" + i).classed("hoved", false);
      select(".barRATEb" + i).classed("hoved", false);
    }
    populateTableFEPComp(
      allData[0],
      allData2[0],
      formatNumber,
      timeFormat("%b %y"),
      comp,
      compRott
    );
  };

  hLineCreate(svg, customName, grayLightBackground(colorTheme), 1);
  bandsCreate(
    data1,
    svg,
    customName,
    mouseOver,
    mouseLeave,
    mouseOver,
    chartNum === 1,
    "id"
  );
  populateTableFEPComp(
    allData[0],
    allData2[0],
    formatNumber,
    timeFormat("%b %y"),
    comp,
    compRott
  );
};
